import { getStorage } from "@/utils/storage";

export default {
  namespaced: true,
  state: {
    farmInfo: getStorage("FARMINFO") || {},
  },
  getters: {
    farmName(state) {
      return state.farmInfo.farmName;
    },
    // 当前农场所在地
    farmLocation(state) {
      const { provinceName, cityName, countyName, townName, villageName } =
        state.farmInfo;
      return [provinceName, cityName, countyName, townName, villageName]
        .filter((name) => !!name)
        .join("/");
    },
  },
};
